export function toFarsiNumber  (n) {
  const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

  return n
    .toString()
    .split('')
    .map(x => farsiDigits[x])
    .join('');
}
